import { AppRoutes } from '@constants/app-routes'
import { OrangeLink } from '@ui/links/OrangeLink'

export const config = {
  title: 'Visual design',
  text: (
    <>
      We paid special attention to the visual hierarchy of the app, using
      various design elements to indicate the importance of different pieces of
      content.
      <br />
      <br />
      For example, we used larger headings to introduce new topics and smaller
      subheadings to break down big sections of text. To reinforce key concepts
      and add visual attractiveness, we also inserted images and icons.
      <br />
      <br />
      Accessibility was another important consideration in{' '}
      <OrangeLink href={AppRoutes.designStudio}>our design process</OrangeLink>.
      We made sure that the application was easy to navigate and use for all
      users, regardless of their abilities. This included using high-contrast
      colors, providing alt text for images, and choosing typography that was
      easy to read for users with visual impairments.
    </>
  ),
  firstVideo: {
    wrapHeight: '64.25%',
    url: '/media/design-991-case1.webm',
  },
  secondVideo: {
    wrapHeight: '64.25%',
    url: '/media/design-991-case2.webm',
  },
}
